import { documentToReactComponents as renderRichText } from '@contentful/rich-text-react-renderer'
import { BLOCKS, INLINES } from '@contentful/rich-text-types'
import React from 'react'

import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'
import { ShareButton } from '@components/ShareButton'
import { ShareEmailForm } from '@forms/ShareEmailForm'
import { ArticleTitleImage } from '@ui/article/ArticleTitleImage'
import { OrangeLink } from '@ui/links/OrangeLink'

import { config } from './config'
import {
  Article,
  ImageWrapper,
  ImageSectionWrapper,
  Wrapper,
  CustomLink,
} from './styles'

const { HOST } = process.env
const HOSTNAME = `www.${HOST?.split('//')[1]}`

const renderOptions = {
  renderNode: {
    [INLINES.HYPERLINK]: (node, children) => {
      const url = new URL(node.data.uri)
      const title = url.hostname === HOSTNAME ? url.pathname : node.data.uri

      return (
        <OrangeLink href={node.data.uri} title={title} inherit>
          {children}
        </OrangeLink>
      )
    },
    [BLOCKS.PARAGRAPH]: (node, children) => <Article>{children}</Article>,
    [BLOCKS.LIST_ITEM]: (node, children) => <li>{children}</li>,
    [BLOCKS.EMBEDDED_ASSET]: node => {
      const target = node.data.target.fields
      return (
        <ImageWrapper>
          <ImageWithPlaceholder
            src={`https:${target.file.url}`}
            width={target.file.details.image.width}
            height={target.file.details.image.height}
            alt={target.title}
            title={target.title}
          />
        </ImageWrapper>
      )
    },
    [BLOCKS.EMBEDDED_ENTRY]: node => {
      const target = node.data.target.fields
      return (
        <ImageWrapper>
          <CustomLink href={target.url}>
            <ImageWithPlaceholder
              src={`https:${target.image.fields.file.url}`}
              width={target.image.fields.file.details.image.width}
              height={target.image.fields.file.details.image.height}
              alt={target.title}
              title={target.title}
            />
          </CustomLink>
        </ImageWrapper>
      )
    },
  },
}

const renderTitle = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => <span>{children}</span>,
  },
}

export function NewsArticle({ news }) {
  const { newsHeadline, titleImage, blackTitleText, content } = news
  return (
    <>
      <ImageSectionWrapper>
        <ArticleTitleImage
          title={renderRichText(newsHeadline, renderTitle)}
          imagePath={titleImage ? `https:${titleImage.fields.file.url}` : '/'}
          textColor={blackTitleText ? 'black' : 'white'}
          textAlign="start"
          imageTitle={titleImage ? titleImage.fields.title : ''}
          imageAlt={titleImage ? titleImage.fields.title : ''}
          titleWidth="890px"
          titleTransform="60%"
          withBreadCrumbs={false}
        />
      </ImageSectionWrapper>
      <Wrapper>
        {renderRichText(content, renderOptions)}
        <ShareButton />
      </Wrapper>
      <ShareEmailForm
        title={config.titleShareEmailForm}
        imageDetail={config.imageShareEmailForm}
        titleSubmited={config.titleShareEmailFormSubmited}
        imageDetailSubmited={config.imageShareEmailFormSubmited}
      />
    </>
  )
}
